(function () {
  const headerSection = document.querySelector('.header-section');

  function onScroll() {
    if (headerSection) headerSection.classList.toggle('header-section--scrolled', window.scrollY > 30);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const actions = document.querySelector('header-actions');
  if (actions && !actions.querySelector('.desire-wishlist')) {
    const wish = document.createElement('a');
    wish.href = '/pages/wishlist';
    wish.className = 'desire-wishlist header-actions__action';
    wish.setAttribute('aria-label', 'Wunschliste');
    wish.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    const cart = actions.querySelector('cart-icon, a[href*="cart"]');
    if (cart && cart.parentElement) {
      cart.parentElement.insertBefore(wish, cart.parentElement.firstChild);
    } else {
      actions.prepend(wish);
    }
  }

  const WISH_KEY = 'desire-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function setWishlist(ids) {
    localStorage.setItem(WISH_KEY, JSON.stringify(ids));
  }

  function syncWishlistButtons() {
    const ids = getWishlist();
    document.querySelectorAll('[data-desire-wishlist-toggle]').forEach((btn) => {
      const id = btn.dataset.productId;
      const active = ids.includes(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-desire-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.productId;
    if (!id) return;
    let ids = getWishlist();
    if (ids.includes(id)) {
      ids = ids.filter((x) => x !== id);
    } else {
      ids.push(id);
    }
    setWishlist(ids);
    syncWishlistButtons();
  });

  syncWishlistButtons();
  document.addEventListener('shopify:section:load', syncWishlistButtons);

  function enhanceWhatsAppLinks() {
    document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]').forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
      link.classList.add('desire-menu-link--whatsapp');
    });
  }

  enhanceWhatsAppLinks();
  document.addEventListener('shopify:section:load', enhanceWhatsAppLinks);

  function initUtilityTicker(root) {
    if (!root || root.dataset.static === 'true') return;

    const slides = [...root.querySelectorAll('.desire-utility-bar__slide')];
    if (slides.length < 2) return;

    let index = 0;
    const interval = Math.max(3, parseInt(root.dataset.interval, 10) || 4) * 1000;

    const tick = () => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    };

    if (root._desireTickerId) window.clearInterval(root._desireTickerId);
    root._desireTickerId = window.setInterval(tick, interval);
  }

  function initAllUtilityTickers() {
    document.querySelectorAll('[data-desire-utility-ticker]').forEach(initUtilityTicker);
  }

  initAllUtilityTickers();
  document.addEventListener('shopify:section:load', initAllUtilityTickers);
})();
